
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/reference",
      function () {
        return require("private-next-pages/apipages/reference/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/reference"])
      });
    }
  